import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorGiveawayCreate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M16.132 10.229c.13-.537.566-.991 1.118-.991h.5v.012h1.85A2.75 2.75 0 0 1 22.35 12v7a2.75 2.75 0 0 1-2.75 2.75h-15A2.75 2.75 0 0 1 1.85 19v-7A2.75 2.75 0 0 1 4.6 9.25h1.806v-.012h.5c.552 0 .987.454 1.118.99a4.174 4.174 0 0 0 8.108 0Zm1.414.521a5.675 5.675 0 0 1-10.937 0H4.6c-.69 0-1.25.56-1.25 1.25v7c0 .69.56 1.25 1.25 1.25h15c.69 0 1.25-.56 1.25-1.25v-7c0-.69-.56-1.25-1.25-1.25h-2.054Z"
    />
    <path
      fill="#F7A600"
      d="M12.82 1.47a.75.75 0 0 0-1.06 0L7.97 5.26a.75.75 0 0 0 1.06 1.06l2.51-2.509v6.82a.75.75 0 1 0 1.5 0v-6.82l2.509 2.509a.75.75 0 0 0 1.06-1.06l-3.79-3.79Z"
    />
  </svg>
);
export default SvgTwoColorGiveawayCreate;
